import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-booking-driver',
  templateUrl: './table-booking-driver.component.html',
  styleUrls: ['./table-booking-driver.component.scss']
})
export class TableBookingDriverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
